<template>
  <el-card :body-style="{ height: '100%' }" class="h-full">
    <div class="h-full flex flex-col">
      <div class="h-full overflow-x-hidden flex-auto">
        <div class="flex items-center h-32px" v-if="canEdit">
          <p class="pl-10px border-l-3px text-18px border-color-primary">{{ title }}</p>
        </div>
        <el-page-header v-else :content="title" @back="$emit('cancel')"></el-page-header>
        <el-tabs v-model="activeTab" class="h-[calc(100%-32px)]">
          <el-tab-pane label="基本信息" name="basic">
            <el-form
              ref="form"
              class="my-20px evaluation-form"
              :model="form"
              label-width="150px"
              :disabled="!canEdit"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="`${$t('评价名称')}`"
                    prop="name"
                    :rules="[
                      {
                        required: true,
                        message: `${$t('请输入评价名称')}`,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.name"
                      :placeholder="`${$t('请输入')}`"
                      :maxlength="50"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="`${$t(`${sourceText}单位`)}`"
                    prop="organizationId"
                    :rules="[
                      {
                        required: true,
                        message: `${$t(`请选择${sourceText}单位`)}`,
                        trigger: 'change',
                      },
                    ]"
                  >
                    <select-tree
                      v-model="form.organizationId"
                      :optionList="departmentList"
                      :treeProps="{
                        label: 'displayName',
                        children: 'children',
                      }"
                      placeholder="请选择"
                      class="w-full"
                    />
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="8" v-else>
                  <el-form-item
                    :label="`${$t(`${sourceText}单位`)}`"
                    prop="organizationId"
                    :rules="[
                      {
                        required: true,
                        message: `${$t(`请输入${sourceText}单位`)}`,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.organizationId"
                      :placeholder="`${$t('请输入')}`"
                      :maxlength="50"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :span="8">
                  <el-form-item :label="`${$t('所属标段')}`" prop="section" v-if="source === 0">
                    <el-input
                      v-model="form.section"
                      :placeholder="`${$t('请输入')}`"
                      :maxlength="50"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="`${$t(`${sourceText}标准`)}`"
                    prop="safetyEvaluationIndexId"
                    :rules="[
                      {
                        required: true,
                        message: `${$t(`请选择${sourceText}标准`)}`,
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-select
                      v-model="form.safetyEvaluationIndexId"
                      :placeholder="`${$t('请选择')}`"
                      filterable
                      clearable
                      class="w-full"
                      @change="changeStandard"
                    >
                      <el-option
                        v-for="item in standardList"
                        :key="item.id"
                        :label="`${item.chapter} ${item.name}`"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="`${$t(`${sourceText}开始时间`)}`"
                    prop="beginTime"
                    :rules="[
                      {
                        required: true,
                        message: `${$t(`请选择${sourceText}开始时间`)}`,
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="form.beginTime"
                      type="date"
                      class="!w-full"
                      placeholder="请选择"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="`${$t(`${sourceText}结束时间`)}`" prop="endTime">
                    <el-date-picker
                      v-model="form.endTime"
                      type="date"
                      disabled
                      class="!w-full"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-collapse v-model="collapseActiveName">
                <el-collapse-item>
                  <template slot="title">
                    <div class="flex justify-between items-center w-full mr-10px">
                      <span>{{ $t('评审人员及小组信息') }}</span>
                      <div>
                        <el-button
                          size="small"
                          type="primary"
                          v-if="canEdit"
                          @click.stop="addGroup"
                          >{{ $t('新增') }}</el-button
                        >
                      </div>
                    </div>
                  </template>
                  <el-table :data="form.participants" stripe border>
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column :label="`${$t('小组')}`" width="200">
                      <template slot-scope="scope">
                        <el-form-item
                          label=""
                          label-width="0"
                          class="mt-20px"
                          :prop="`participants[${scope.$index}].group`"
                          :rules="[
                            {
                              required: true,
                              message: `${$t('请填写小组')}`,
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            v-model="scope.row.group"
                            :placeholder="`${$t('请输入')}`"
                            :maxlength="50"
                            show-word-limit
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('姓名')}`" width="200">
                      <template slot-scope="scope">
                        <el-form-item
                          label=""
                          label-width="0"
                          class="mt-20px"
                          :prop="`participants[${scope.$index}].name`"
                          :rules="[
                            {
                              required: true,
                              message: `${$t('请填写姓名')}`,
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            v-model="scope.row.name"
                            :placeholder="`${$t('请输入')}`"
                            :maxlength="50"
                            show-word-limit
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('主要分工')}`">
                      <template slot-scope="scope">
                        <el-form-item
                          label=""
                          label-width="0"
                          class="mt-20px"
                          :prop="`participants[${scope.$index}].mainWork`"
                          :rules="[
                            {
                              required: true,
                              message: `${$t('请填写主要分工')}`,
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            v-model="scope.row.mainWork"
                            :placeholder="`${$t('请输入')}`"
                            :maxlength="1000"
                            show-word-limit
                            type="textarea"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('操作')}`" width="80" v-if="canEdit">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="
                            deleteRow(form.participants, scope.$index, form.removedParticipants)
                          "
                          >{{ $t('删除') }}</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
                <el-collapse-item>
                  <template slot="title">
                    <div class="flex justify-between items-center w-full mr-10px">
                      <span>{{ $t('基本条件评审') }}</span>
                      <div>
                        <el-button
                          size="small"
                          type="primary"
                          v-if="canEdit"
                          @click.stop="addBasicCondition"
                          >{{ $t('新增') }}</el-button
                        >
                      </div>
                    </div>
                  </template>
                  <el-table :data="form.bases" stripe border>
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column :label="`${$t('评审项目')}`">
                      <template slot-scope="scope">
                        <el-form-item
                          label=""
                          label-width="0"
                          class="mt-20px"
                          :prop="`bases[${scope.$index}].project`"
                          :rules="[
                            {
                              required: true,
                              message: `${$t('请填写评审项目')}`,
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            v-model="scope.row.project"
                            :placeholder="`${$t('请输入')}`"
                            :maxlength="1000"
                            show-word-limit
                            type="textarea"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('检查情况')}`">
                      <template slot-scope="scope">
                        <el-form-item
                          label=""
                          label-width="0"
                          class="mt-20px"
                          :prop="`bases[${scope.$index}].inspection`"
                          :rules="[
                            {
                              required: true,
                              message: `${$t('请填写检查情况')}`,
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            v-model="scope.row.inspection"
                            :placeholder="`${$t('请输入')}`"
                            :maxlength="1000"
                            show-word-limit
                            type="textarea"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('结论')}`">
                      <template slot-scope="scope">
                        <el-form-item
                          label=""
                          label-width="0"
                          class="mt-20px"
                          :prop="`bases[${scope.$index}].conclusion`"
                          :rules="[
                            {
                              required: true,
                              message: `${$t('请填写结论')}`,
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            v-model="scope.row.conclusion"
                            :placeholder="`${$t('请输入')}`"
                            :maxlength="1000"
                            show-word-limit
                            type="textarea"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('操作')}`" width="80" v-if="canEdit">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="deleteRow(form.bases, scope.$index, form.removedBases)"
                          >{{ $t('删除') }}</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
                <el-collapse-item>
                  <template slot="title">
                    <div class="flex justify-between items-center w-full mr-10px">
                      <span>{{ $t('核心要素（评分项目）无关项说明') }}</span>
                      <div>
                        <el-button
                          size="small"
                          type="primary"
                          v-if="canEdit"
                          @click.stop="addIrrelevant"
                          >{{ $t('引用') }}</el-button
                        >
                      </div>
                    </div>
                  </template>
                  <el-table :data="form.disconnectedItems" stripe border>
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column :label="`${$t('项目名称')}`" prop="project" width="200">
                    </el-table-column>
                    <el-table-column :label="`${$t('分值')}`" prop="standardScore" width="200">
                    </el-table-column>
                    <el-table-column :label="`${$t('无关项原因')}`">
                      <template slot-scope="scope">
                        <el-form-item
                          label=""
                          label-width="0"
                          class="mt-20px"
                          :prop="`disconnectedItems[${scope.$index}].reason`"
                          :rules="[
                            {
                              required: true,
                              message: `${$t('请填写无关项原因')}`,
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            v-model="scope.row.reason"
                            :placeholder="`${$t('请输入')}`"
                            :maxlength="1000"
                            show-word-limit
                            type="textarea"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('操作')}`" width="80" v-if="canEdit">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="
                            deleteRow(
                              form.disconnectedItems,
                              scope.$index,
                              form.removedDisconnectedItems
                            )
                          "
                          >{{ $t('删除') }}</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
                <el-collapse-item v-if="source === 2">
                  <template slot="title">
                    <div class="flex justify-between items-center w-full mr-10px">
                      <span>{{ $t('关联建设方自评记录') }}</span>
                      <div>
                        <el-button
                          size="small"
                          type="primary"
                          v-if="canEdit"
                          @click.stop="addConstructionUnitsolution"
                          >{{ $t('关联') }}</el-button
                        >
                      </div>
                    </div>
                  </template>
                  <el-table :data="form.constructionUnitSolution" stripe border>
                    <el-table-column
                      width="60"
                      :label="`${$t('序号')}`"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="name"
                      show-overflow-tooltip
                      :label="`${$t('评价名称')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="creator"
                      show-overflow-tooltip
                      :label="`${$t('评价人')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="organization"
                      show-overflow-tooltip
                      :label="`${$t('评价单位')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="beginTime"
                      show-overflow-tooltip
                      :label="`${$t('评价开始时间')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="totalStandardScore"
                      show-overflow-tooltip
                      :label="`${$t('评价标准总分')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="totalScore"
                      show-overflow-tooltip
                      :label="`${$t('自评得分')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="scorePercentage"
                      show-overflow-tooltip
                      :label="`${$t('得分占比')}`"
                    ></el-table-column>
                    <el-table-column :label="`${$t('操作')}`" width="80" v-if="canEdit">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="form.constructionUnitSolution.splice(scope.$index, 1)"
                          >{{ $t('删除') }}</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
                <el-collapse-item v-if="source === 2">
                  <template slot="title">
                    <div class="flex justify-between items-center w-full mr-10px">
                      <span>{{ $t('关联相关方自评记录') }}</span>
                      <div>
                        <el-button
                          size="small"
                          type="primary"
                          v-if="canEdit"
                          @click.stop="addRelatedPartySolution"
                          >{{ $t('关联') }}</el-button
                        >
                      </div>
                    </div>
                  </template>
                  <el-table :data="form.relatedPartySolution" stripe border>
                    <el-table-column
                      width="60"
                      :label="`${$t('序号')}`"
                      type="index"
                    ></el-table-column>
                    <el-table-column
                      prop="name"
                      show-overflow-tooltip
                      :label="`${$t('评价名称')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="creator"
                      show-overflow-tooltip
                      :label="`${$t('评价人')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="organization"
                      show-overflow-tooltip
                      :label="`${$t('评价单位')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="beginTime"
                      show-overflow-tooltip
                      :label="`${$t('评价开始时间')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="totalStandardScore"
                      show-overflow-tooltip
                      :label="`${$t('评价标准总分')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="totalScore"
                      show-overflow-tooltip
                      :label="`${$t('自评得分')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="scorePercentage"
                      show-overflow-tooltip
                      :label="`${$t('得分占比')}`"
                    ></el-table-column>
                    <el-table-column :label="`${$t('操作')}`" width="80" v-if="canEdit">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="form.relatedPartySolution.splice(scope.$index, 1)"
                          >{{ $t('删除') }}</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
              </el-collapse>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="评价信息" name="evaluation" class="h-full" v-if="!canEdit">
            <div class="flex h-full pb-20px">
              <div class="w-300px h-full pr-20px">
                <catalog
                  class="w-full border-color-default border-1px border-solid p-10px"
                  @node-click="treeNodeClick"
                  :id="form.id"
                  :status="form.status"
                />
              </div>
              <self-evaluation-table
                class="flex-1"
                :disabled="mode !== 'evaluate'"
                :nodeId="nodeId"
                :nodeData="nodeData"
                :id="form.id"
                :name="form.name"
                :standardName="standardName"
                ref="selfEvaluationTable"
                :source="source"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="text-center pt-20px border-t-1px border-color-default" v-if="mode !== 'read'">
        <el-button
          type="primary"
          size="small"
          @click="save('publish')"
          :loading="saveLoading"
          v-if="form.status === 0"
          >{{ $t('发起评价') }}</el-button
        >
        <el-button type="primary" size="small" @click="saveTip" :loading="tipLoading">{{
          $t('保存')
        }}</el-button>
        <el-button type="primary" size="small" @click="save('save')" :loading="saveLoading">{{
          $t('结束评价')
        }}</el-button>
        <el-button size="small" @click="$emit('cancel')">{{ $t('取消') }}</el-button>
      </div>
    </div>
    <select-irrelevant
      :visible.sync="visibleSelectIrrelevant"
      :id="this.form.safetyEvaluationIndexId"
      :status="this.form.status"
      @save="setIrrelevant"
      :selectedIds="selectedIds"
    />
    <relate-evaluation-list
      :visible.sync="relateEvaluationVisible"
      :max="relatedMax"
      :source="relatedSource"
      :selectedIds="rlatedIds"
      @save="saveRelated"
    />
  </el-card>
</template>

<script>
import { OrganizationApi } from '@wiz-api/abp-identity'
import {
  SafetyEvaluationSolutionApi,
  SafetyEvaluationIndexApi,
} from '@wiz-api/safety-evaluation-management'
import { cloneDeep, map, filter, find, isEmpty } from 'lodash'
import dayjs from 'dayjs'
import { treeToOneArray } from '@/assets/js/common/common'
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'

const SelectTree = () => {
  return import('@/components/safety/FormSelect/SelectTree')
}
const Catalog = () => {
  return import('../components/Catalog')
}
const SelfEvaluationTable = () => {
  return import('../components/SelfEvaluationTable')
}
const SelectIrrelevant = () => {
  return import('../components/SelectIrrelevant')
}
const RelateEvaluationList = () => {
  return import('../components/RelateEvaluationList')
}
const organizationApi = new OrganizationApi()
const safetyEvaluationSolutionApi = new SafetyEvaluationSolutionApi()
const safetyEvaluationIndexApi = new SafetyEvaluationIndexApi()
export default {
  props: {
    mode: {
      type: String,
      default: 'create',
    },
    id: {
      type: String,
      default: '',
    },
    source: {
      type: Number,
      default: 0,
    },
  },
  components: {
    SelectTree,
    Catalog,
    SelfEvaluationTable,
    SelectIrrelevant,
    RelateEvaluationList,
  },
  data() {
    return {
      activeTab: 'basic',
      departmentList: [],
      standardList: [],
      saveLoading: false,
      tipLoading: false, // 保存按钮loading
      form: {
        participants: [],
        bases: [],
        disconnectedItems: [],
        removedParticipants: [],
        removedBases: [],
        removedDisconnectedItems: [],
        relatedPartySolution: [],
        constructionUnitSolution: [],
        status: 0,
      },
      selectedIds: [],
      title: '基本信息',
      collapseActiveName: [0],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() <= Date.now() - 86400000
        },
      },
      nodeId: '',
      visibleSelectIrrelevant: false,
      standardName: '',
      relatedMax: Infinity,
      rlatedIds: [],
      relateEvaluationVisible: false,
      relatedType: '',
      relatedSource: 0,
      flattenDepartment: [],
      nodeData: null, // 文件目录树当前点击节点数据
    }
  },
  computed: {
    sourceText() {
      return this.source === 2 ? '评价' : '自评'
    },
    canEdit() {
      return this.mode !== 'read' && this.mode !== 'evaluate'
    },
  },
  methods: {
    /**
     * @description 文件目录树节点点击
     * @param {Object} nodeData 文件目录树节点数据
     */
    treeNodeClick(nodeData) {
      this.nodeId = nodeData.safetyEvaluationId
      this.nodeData = { ...nodeData }
    },

    init() {
      if (this.mode === 'read' || this.mode === 'evaluate') {
        clearPlaceholder('.evaluation-form')
      }
      console.log(this.mode)
      if (this.mode === 'create') {
        this.$set(this.form, 'beginTime', dayjs().format('YYYY-MM-DD 00:00:00'))
      } else {
        this.getDetail()
      }
    },
    addRelatedPartySolution() {
      this.rlatedIds = map(this.form.relatedPartySolution, 'id')
      this.relatedMax = Infinity
      this.relatedSource = 0
      this.relatedType = 'relatedParty'
      this.relateEvaluationVisible = true
    },
    addConstructionUnitsolution() {
      this.rlatedIds = map(this.form.constructionUnitSolution, 'id')
      this.relatedMax = 1
      this.relatedSource = 1
      this.relatedType = 'constructionUnits'
      this.relateEvaluationVisible = true
    },
    saveRelated(data) {
      if (this.relatedType === 'relatedParty') {
        this.form.relatedPartySolution = data
      } else {
        this.form.constructionUnitSolution = data
      }
    },
    addIrrelevant() {
      if (!this.form.safetyEvaluationIndexId) {
        this.$message.warning('请先选择自评标准')
        return
      }
      this.selectedIds = map(this.form.disconnectedItems, 'safetyEvaluationId')
      this.visibleSelectIrrelevant = true
    },
    setIrrelevant(selection) {
      selection.forEach((item) => {
        this.form.disconnectedItems.push({
          project: item.project,
          standardScore: item.standardScore,
          reason: '',
          safetyEvaluationId: item.id,
        })
      })
    },
    addGroup() {
      this.form.participants.push({
        group: '',
        name: '',
        mainWork: '',
      })
    },
    addBasicCondition() {
      this.form.bases.push({
        project: '',
        inspection: '',
        conclusion: '',
      })
    },
    deleteRow(list, index, removeList) {
      if (list[index].id) {
        removeList.push(list[index].id)
      }
      list.splice(index, 1)
    },
    changeStandard() {
      this.form.removedDisconnectedItems = filter(this.form.disconnectedItems, (item) => {
        return item.id
      })
      this.form.disconnectedItems = []
    },
    async getStandardList() {
      const [err, res] = await safetyEvaluationIndexApi.getRootList()
      if (!err) {
        this.standardList = res
      }
    },
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err && res?.items.length) {
        this.departmentList = res?.items
        // this.departmentList = res?.items[0].children
        this.flattenDepartment = treeToOneArray(this.departmentList, 'children')
      }
    },

    /**
     * @description 弹窗成功信息
     */
    saveTip() {
      this.tipLoading = true
      setTimeout(() => {
        this.$message.success('成功')
        this.tipLoading = false
      }, 500)
    },

    save(type) {
      if (this.mode === 'evaluate') {
        this.saveEvaluation()
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          let apiRes = []
          let msgType = ''
          const body = cloneDeep(this.form)
          body.source = this.source
          body.constructionUnitSolutionId = this.form.constructionUnitSolution.length
            ? this.form.constructionUnitSolution[0].id
            : null
          body.relatedPartySolutionIds = map(this.form.relatedPartySolution, 'id')
          delete body.relatedPartySolution
          delete body.constructionUnitSolution
          body.bases = this.form.bases.map((item, index) => {
            return {
              ...item,
              serial: index,
            }
          })
          body.disconnectedItems = this.form.disconnectedItems.map((item) => {
            const { safetyEvaluationId, reason, id } = item
            return {
              safetyEvaluationId,
              disconnectedReason: reason,
              id,
            }
          })
          if (this.mode === 'create') {
            msgType = '新增'
            apiRes = await safetyEvaluationSolutionApi.create({
              body,
            })
          } else {
            msgType = '编辑'
            apiRes = await safetyEvaluationSolutionApi.update(this.form.id, {
              body,
            })
          }
          this.saveLoading = false
          if (!apiRes[0]) {
            if (type === 'publish') {
              const [err] = await safetyEvaluationSolutionApi.publish(apiRes[1])
              if (!err) {
                this.$message.success('发布成功！')
                this.$emit('refresh')
              }
              return
            }
            this.$message.success(`${msgType}成功！`)
            this.$emit('refresh')
          }
        }
      })
    },
    saveEvaluation() {
      this.$refs.selfEvaluationTable.$refs.form.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const [err] = await safetyEvaluationSolutionApi.complete(this.form.id)
          this.saveLoading = false
          if (!err) {
            this.$message.success('保存成功！')
            this.$emit('refresh')
          }
        }
      })
    },
    async getDetail() {
      const [err, res] = await safetyEvaluationSolutionApi.get(this.id)
      if (!err) {
        const constructionUnitSolution = isEmpty(res.constructionUnitSolution)
          ? []
          : [res.constructionUnitSolution]
        this.form = {
          ...res,
          removedBases: [],
          removedDisconnectedItems: [],
          removedParticipants: [],
          constructionUnitSolution: map(constructionUnitSolution, (item) => {
            return {
              ...item,
              beginTime: dayjs(item.beginTime).format('YYYY-MM-DD'),
              organization: find(this.flattenDepartment, { id: item.organizationId })?.displayName,
            }
          }),
          relatedPartySolution: map(res.relatedPartySolution, (item) => {
            return {
              ...item,
              beginTime: dayjs(item.beginTime).format('YYYY-MM-DD'),
              organization: find(this.flattenDepartment, { id: item.organizationId })?.displayName,
            }
          }),
        }
      }
      const standard = find(this.standardList, { id: this.form.safetyEvaluationIndexId })
      this.standardName = `${standard?.chapter} ${standard?.name}`
    },
  },
  async mounted() {
    await this.getOrgData()
    await this.getStandardList()
    this.init()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
  overflow-y: auto;
}
</style>
